import { createFileRoute } from '@tanstack/react-router'
import { LendMiningPage } from '@/features/mining/lend-mining/LendMiningPage'

export const Route = createFileRoute('/_app/mining/lend')({
  component: LendMiningPage,
})
